import * as React from "react"
import AccountCircleIcon from "@mui/icons-material/AccountCircle"
import { CircularProgress, Container, Paper } from "@mui/material"
import Typography from "@mui/material/Typography"
import Box from "@mui/material/Box"
import { Button, Grid, AppBar, Toolbar } from "@mui/material"
import { Link, useSearchParams } from "react-router-dom"
import Modal from "react-bootstrap/Modal"
import HelpIcon from "@mui/icons-material/Help"
import { useOutletContext } from "react-router-dom/dist"
import { useParams } from "react-router-dom"
import { useState } from "react"
import { useEffect } from "react"
import { toast } from "react-toastify"
import { Helmet } from "react-helmet"
import Paginate from "../../components/mui/Paginate"
import apiClient from "../../api/apiClient"
import useApi from "../../hooks/useApi"
import { formatDate, objectToQueryString } from "../../modules/helpers"
import ShopFilterSidebar from "../../components/sidebar-filter/ProductFilterSidebar"
import LoadingOverlay from "../../components/mui/LoadingOverlay"
import axios from "axios"
import ReportDownloadModal from "../../components/ReportDownloadModal"

const baseURL = process.env.REACT_APP_BASE_URL

const ClientSubmittedReport = () => {
  const [searchParams, setSearchParams] = useSearchParams()
  const urlPage = parseInt(searchParams.get("page")) || 1
  const [count, setCount] = useState(0)
  const [page, setPage] = useState(urlPage)
  const [showFilter, setShowFilter] = useState(false)
  const [date, setDate] = useState([])
  const [reset, setReset] = useState(false)
  const [isDownloading, setIsDownloading] = useState(false)
  const [reportDownloadBarcode, setReportDownloadBarcode] = useState("")

  const intialFilters = {
    start_date: searchParams.get("start_date") || "",
    end_date: searchParams.get("end_date") || "",
    date_search_type: searchParams.get("date_search_type") || "client",
    keyword: searchParams.get("keyword") || "barcode",
    search: searchParams.get("search") || "",
    archive: searchParams.get("archive") === "true"
  }
  const [filters, setFilters] = useState(intialFilters)
  useEffect(() => {
    if (intialFilters.start_date && intialFilters.end_date) {
      setDate([intialFilters.start_date, intialFilters.end_date])
    }
  }, [])
  const onReset = () => {
    setFilters({
      start_date: "",
      end_date: "",
      date_search_type: "client",
      keyword: "barcode",
      search: "",
      archive: false
    })
    setDate([])
    setPage(1)
    setSearchParams({})
    setReset(true)
  }
  const onFilterChange = (key, value) => {
    setFilters({ ...filters, [key]: value })
  }
  useEffect(() => {
    if (reset) fetchData()
  }, [reset])
  const { request, error, data, loading } = useApi(route => apiClient.get(route))
  console.log(data, "fghu data")

  const fetchData = async (currentPage = page) => {
    const filterObject = {
      start_date: date?.[0] || "",
      end_date: date?.[1] || "",
      date_search_type: filters.date_search_type,
      archive: filters.archive,
      keyword: filters.keyword,
      search: filters.search
    }
    const params = new URLSearchParams()
    if (filterObject.start_date) params.set("start_date", filterObject.start_date)
    if (filterObject.end_date) params.set("end_date", filterObject.end_date)
    if (filterObject.date_search_type !== "client") params.set("date_search_type", filterObject.date_search_type)
    if (filterObject.keyword !== "barcode") params.set("keyword", filterObject.keyword)
    if (filterObject.search) params.set("search", filterObject.search)
    if (filterObject.archive) params.set("archive", "true")
    if (currentPage > 1) params.set("page", currentPage)
    setSearchParams(params)
    setPage(currentPage)

    if (currentPage == 1 && count) setCount(0)
    //   const result = await request(`/sample/?sampleStatus=${status}`);
    const result = await request(
      `/sample/?limit=10&page=${currentPage}&${objectToQueryString({
        start_date: filterObject.start_date,
        end_date: filterObject.end_date,
        date_search_type: filterObject.date_search_type,
        archive: filterObject.archive,
        [filterObject.keyword]: filterObject.search
      })}`
    )
    setReset(false)
    if (!count || currentPage == 1 || count !== result.data.count) setCount(result.data.count)
  }

  const handlePageChange = (event, value) => {
    fetchData(value)
  }

  useEffect(() => {
    fetchData(page)
  }, [])

  const openReportDownloadModal = barcode => {
    setReportDownloadBarcode(barcode)
  }

  const closeReportDownloadModal = () => {
    if (!isDownloading) setReportDownloadBarcode("")
  }

  const handleDownload = async regenerate => {
    const barcode = reportDownloadBarcode
    if (!barcode) return

    setIsDownloading(true)
    try {
      const token = localStorage.getItem("token")
      const response = await axios.get(`${baseURL}report/download/${barcode}`, {
        responseType: "blob",
        headers: {
          Accept: "application/pdf",
          ...(token ? { Authorization: `Bearer ${token}` } : {})
        },
        timeout: 60000,
        params: regenerate ? { regenerate: true } : {}
      })

      if (response.status !== 200) {
        throw new Error("Unexpected response while downloading report")
      }

      const url = window.URL.createObjectURL(new Blob([response.data], { type: "application/pdf" }))
      const link = document.createElement("a")
      link.href = url
      link.setAttribute("download", `report_${barcode}.pdf`)
      document.body.appendChild(link)
      link.click()
      link.parentNode.removeChild(link)
      window.URL.revokeObjectURL(url)
    } catch (error) {
      toast.error("Error")
    } finally {
      setIsDownloading(false)
      setReportDownloadBarcode("")
    }
  }

  return (
    <div>
      <Helmet>
        <title>Reports</title>
      </Helmet>
      <LoadingOverlay open={isDownloading && !reportDownloadBarcode} />
      <Container maxWidth={false} sx={{ maxWidth: 1180, px: { xs: 2, md: 3 } }}>
          <ShopFilterSidebar
            openFilter={showFilter}
            onOpenFilter={() => setShowFilter(true)}
            onCloseFilter={() => setShowFilter(false)}
            handleChange={onFilterChange}
            values={filters}
            onReset={onReset}
            fetchData={() => fetchData(1)}
            date={date}
            setDate={setDate}
          />
      </Container>
      <Container maxWidth={false} sx={{ maxWidth: 1180, px: { xs: 2, md: 3 } }}>
      <Grid container>
        <Grid className=" d-flex justify-content-center" item md={12} xs={12}>
          <Grid item xs={12}>
            <h5 className="my-3">Reports data:</h5>
            {!loading ? (
              <>
                {data.map(({ client, technician, sampleStatus, ...otherSampleItem }, index) => (
                  <div
                    className=" row justify-content-center d-flex gy-2 gx-2 flex-wrap px-4 mb-5"
                    style={{
                      backgroundColor: "#F1F1F5",
                      // color:"white",
                      borderRadius: 15,
                      alignItems: "center",
                      paddingTop: 40,
                      paddingBottom: 40
                    }}
                  >
                    <div className="col-1 d-flex align-items-start h-100">
                      <AccountCircleIcon fontSize="large" />
                    </div>
                    <div className="col-md-8">
                      <div className="row flex-wrap">
                        {/* First set of information */}

                        <div className="col-6">
                          <Typography className="fs_14" variant="body2" sx={{ fontWeight: "bold" }}>
                            Name:
                          </Typography>
                          <Typography className="fs_10px" sx={{ fontWeight: "bold" }}>
                            {client.firstname + " " + client.lastname}
                          </Typography>
                        </div>

                        <div className="col-6">
                          <Typography className="fs_14" variant="body2" sx={{ fontWeight: "bold" }}>
                            Address:
                          </Typography>
                          <Typography className="fs_10px">{client.address}</Typography>
                        </div>

                        {/* Second set of information */}
                        <div className="col-6">
                          <Typography variant="body2" component="p" sx={{ fontWeight: "bold" }}>
                            Email
                          </Typography>
                          <Typography variant="body2" component="p" sx={{ fontSize: "0.7rem" }}>
                            {client.email}
                          </Typography>
                        </div>

                        <div className="col-6">
                          <Typography variant="body2" component="p" sx={{ fontWeight: "bold" }}>
                            Contact
                          </Typography>
                          <Typography variant="body2" component="p" sx={{ fontSize: "0.7rem" }}>
                            {client.phone_no}
                          </Typography>
                        </div>

                        {/* Third set of information */}
                        <div className="col-6">
                          <Typography variant="body2" component="p" sx={{ fontWeight: "bold" }}>
                            Pet Name
                          </Typography>
                          <Typography variant="body2" component="p" sx={{ fontSize: "0.7rem" }}>
                            {client.pet.pet_name}
                          </Typography>
                        </div>

                        <div className="col-6">
                          <Typography variant="body2" component="p" sx={{ fontWeight: "bold" }}>
                            Barcode
                          </Typography>
                          <Typography variant="body2" component="p" sx={{ fontSize: "0.7rem" }}>
                            {client.barcode}
                          </Typography>
                        </div>
                        <div className="col-6">
                          <Typography variant="body2" component="p" sx={{ fontWeight: "bold" }}>
                            Client Register Date
                          </Typography>
                          <Typography variant="body2" component="p" sx={{ fontSize: "0.7rem" }}>
                            {formatDate(client?.createdAt, "MMMM D, YYYY [at] h:mma")}
                          </Typography>
                        </div>
                        <div className="col-6">
                          <Typography variant="body2" component="p" sx={{ fontWeight: "bold" }}>
                            Sample Receive Date
                          </Typography>
                          <Typography variant="body2" component="p" sx={{ fontSize: "0.7rem" }}>
                            {formatDate(otherSampleItem?.createdAt, "MMMM D, YYYY [at] h:mma")}
                          </Typography>
                        </div>
                        <div className="col-6">
                          <Typography variant="body2" component="p" sx={{ fontWeight: "bold" }}>
                            Report Create Date
                          </Typography>
                          <Typography
                            variant="body2"
                            component="p"
                            sx={{
                              color: otherSampleItem?.submitted_at ? "inherit" : "text.secondary",
                              fontSize: "0.7rem"
                            }}
                          >
                            {otherSampleItem?.submitted_at
                              ? formatDate(otherSampleItem?.submitted_at, "MMMM D, YYYY [at] h:mma")
                              : "Not generated yet"}
                          </Typography>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-3 d-flex flex-column flex-sm-row">
                      <Box className="">
                        <Typography
                          className="fs_14px"
                          variant="span"
                          sx={{ display: "block", ml: 1, fontWeight: "bold" }}
                        >
                          Technician name
                        </Typography>
                        <Typography
                          className="fs_14px"
                          variant="span"
                          sx={{ display: "block", ml: 1 }}
                        >
                          {technician?.name}
                        </Typography>
                        <Button
                          sx={{}}
                          onClick={() => openReportDownloadModal(client.barcode)}
                          disabled={sampleStatus !== "SUB"}
                          className=" m-2 btn btn_bg_secondery"
                          variant="contained"
                        >
                          Generate Report
                        </Button>
                        <Button
                          component={sampleStatus === "SUB" ? Link : "button"}
                          to={sampleStatus === "SUB" ? `/get-report/${client.barcode}` : undefined}
                          disabled={sampleStatus !== "SUB"}
                          className="m-2 btn btn_bg_secondery"
                          variant="contained"
                        >
                          View Report
                        </Button>
                      </Box>
                    </div>
                  </div>
                ))}
              </>
            ) : (
              <Box sx={{ display: "flex", justifyContent: "center" }}>
                <CircularProgress />
              </Box>
            )}
            <div className={`${loading && "d-none"}`}>
              <Paginate style={{ color: "white" }} count={count} page={page} onChange={handlePageChange} />
            </div>
          </Grid>
        </Grid>
      </Grid>
      </Container>
      <ReportDownloadModal
        show={Boolean(reportDownloadBarcode)}
        onHide={closeReportDownloadModal}
        onSelect={handleDownload}
        loading={isDownloading}
      />
    </div>
  )
}

export default ClientSubmittedReport
